(function(doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            var docEl = doc.documentElement, l = docEl.clientWidth, f;
                f = l / 18;
                 l > 720 ? docEl.style.fontSize = 40 + "px" : docEl.style.fontSize = f + "px";
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);